<template>
  <div class="safeProductionCommittee">
    <ComList
      :PageSize.sync="PageSize"
      :PageNo.sync="PageNo"
      :Total.sync="Total"
      infoColumn="15"
      baseDetailsUrl="committeeDetails"
      listType="newsList"
    ></ComList>
  </div>
</template>
<script>
import ComList from "../../components/news/comList";
// 安全生产专业委员会
export default {
  data() {
    return {
      Total: 1, // 总数
      PageNo: 1, // 当前页
      PageSize: 5, // 每页显示条数
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {},
  components: { ComList },
};
</script>
<style lang="scss">
.safeProductionCommittee {
  position: relative;
  .comList {
    margin: 30px auto 50px !important;
    &::before {
      content: "";
      left: 220px;
    }
  }
}
</style>
